import { CATALOG_KEY_TO_COLUMN_NAME_MAP } from "../consts";
import { CatalogDataResponseItem } from "../types";
import { parseBooleanToText } from "./parse-boolean-to-text.util";
import { getBuyPriceFromPricesItem, getConstruction, getIsColored, getIsPhotochromic, getIsPolarising, getMaterial, getName, getSellPriceFromPricesItem, getShellList, getSingleCatalogNumber, getType } from "./parse-response-to-fields.util";

export const getParsedRowData = (data: CatalogDataResponseItem, options: { vatPercent: number; producer: string; purpose: string, merchandiseType: string; }) => {
    const dataByKeys: Record<keyof typeof CATALOG_KEY_TO_COLUMN_NAME_MAP, unknown> = {
        A: getName(data),
        B: getSingleCatalogNumber(data.catalogNumbers[0]),
        C: 0,
        D: options.merchandiseType,
        E: options.vatPercent,
        F: getBuyPriceFromPricesItem(data.prices[0]),
        G: getSellPriceFromPricesItem(data.prices[0]),
        H: options.producer,
        I: parseBooleanToText(getIsPhotochromic(data)),
        J: 0,
        K: getIsPhotochromic(data) ? data.colors[0].name : 0,
        L: parseBooleanToText(getIsPolarising(data)),
        M: getIsPolarising(data) ? data.colors[0].name : 0,
        N: options.purpose,
        O: getMaterial(data),
        P: getConstruction(data),
        Q: getType(data),
        R: parseBooleanToText(getIsColored(data)),
        S: 0,
        T: 0,
        U: 0,
        V: 0,
        W: getShellList(data)
    }

    return Object.keys(dataByKeys).reduce((acc, curr) => {
        const currentKey = curr as keyof typeof CATALOG_KEY_TO_COLUMN_NAME_MAP
        const parsedKey = CATALOG_KEY_TO_COLUMN_NAME_MAP[currentKey];

        acc[parsedKey] = dataByKeys[currentKey]

        return acc;
    }, {} as Record<string, unknown>)
}